import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const ShopifyEcommerce: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary fw-400">
              Businesses of all sizes are transitioning from brick-and-mortar to the online space with Shopify, which provides a host of advantages for retailers. Shopify is an e-commerce platform that manages the entire product cycle or inventory management, including shipping, delivery, content, and payments. This is why many eCommerce stores choose to migrate to Shopify&apos;s cloud-based platform.</p>

              <p className="fs-md text-secondary mb-0 fw-400">
              Moweb is a leading company providing Shopify Development Services to give you exactly what you require to achieve your growth. Our development team consists of versatile Shopify experts with vast experience in Shopify web designing, development, customization, integration, and migration.
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-9">
             <p className="fs-md text-secondary fw-400 mb-2.5">
             Hire our Shopify developers to curate responsive, user-friendly, and interactive Shopify themes. Our Shopify website developers understand Liquid File, GraphQL, StoreFront APIs, Redis, Node.js, React, Ruby on Rails, etc. We are committed to delivering exceptional results and succeeding in the world of e-commerce with features such as –
          </p>
          <div className="row grid grid-cols-2">
          <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
              <KEYBlue text="Customizable themes " />
              <KEYBlue text=" POS Integrations" />
              <KEYBlue text="Custom Metafilds " />
              <KEYBlue text="Product Multiple Variants " />
              <KEYBlue text="3rd party app integrations " />
            </div>
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text=" Mobile responsiveness" />
            <KEYBlue text=" Shopify Tags " />
            <KEYBlue text="Inventory Management " />
            <KEYBlue text=" SEO and marketing tools" />
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ShopifyEcommerce
